export const NETWORK_ERROR = "Please Check Your Internet.";
export const UN_AUTHORIZED_ERROR = "Unauthorized access. Please log in again.";
export const PERMISSION_ERROR =
  "You do not have permission to perform this action.";
export const NOT_FOUND_ERROR = "API URL is not correct";
export const SERVER_ERROR = "Server error. Please try again later.";
export const SERVER_NOT_RESPONDING_ISSUE ="We are having trouble reaching our servers. Please try again later."
export const REQUEST_TIMEOUT_ERROR = 'Request timed out. Please try again.';
